module.exports = __webpack_public_path__ + "static/img/default.6b914f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/default.jpg
// module id = jp2k
// module chunks = 119